const getExtension = value => {
  const rawValue = String(value ?? "").trim().toLowerCase();

  // Handle MIME types like `application/pdf` and `image/svg+xml`.
  if (!rawValue.startsWith("http") && rawValue.includes("/")) {
    const mimeSubtype = rawValue.split(";")[0].split("/").pop() || "";
    return mimeSubtype.split("+")[0];
  }

  const source = rawValue.split("?")[0].split("#")[0];
  const parts = source.split(".");
  if (parts.length > 1) {
    return parts.pop().toLowerCase();
  }

  // Some stored file names are sanitized as `name_pdf`.
  const underscoreParts = source.split("_");
  if (underscoreParts.length > 1) {
    return underscoreParts.pop().toLowerCase();
  }

  // `fileType` can arrive as a raw extension such as "pdf".
  return rawValue.replace(/[^a-z0-9]/g, "");
};

const isPreviewableDocument = values => {
  const previewableExtensions = [
    "pdf",
    "jpg",
    "jpeg",
    "png",
    "svg",
    "webp",
    "txt",
    "csv",
  ];
  const fileType = getExtension(values?.fileType);
  const fileNameType = getExtension(values?.fileName);
  const viewUrlType = getExtension(values?.viewUrl);
  return [fileType, fileNameType, viewUrlType].some(extension =>
    previewableExtensions.includes(extension),
  );
};

export { getExtension, isPreviewableDocument };
